import { SearchEntity } from '@finance-lab/utils/types'

export const getUrlForType = (option: Pick<SearchEntity, 'type' | 'id'>) => {
    if (option.type === 'issue') {
        return `/issues/${option.id}`
    } else if (option.type === 'warrant') {
        return `/warrants/${option.id}`
    } else if (option.type === 'company') {
        return `/companies/${option.id}`
    } else if (option.type === 'investor') {
        return `/investors/${option.id}`
    } else if (option.type === 'convertible') {
        return `/convertibles/${option.id}`
    }
    return '' // If no matching type is found
}
